import { render } from "./InvoiceViewSecretary.vue?vue&type=template&id=ed62a144&scoped=true"
import script from "./InvoiceViewSecretary.vue?vue&type=script&lang=js"
export * from "./InvoiceViewSecretary.vue?vue&type=script&lang=js"

import "./InvoiceViewSecretary.vue?vue&type=style&index=0&id=ed62a144&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed62a144"]])

export default __exports__